// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1nml6","alertIcon":"ConfirmModal_alertIcon__1LGsj"};